import debounce from 'lodash/debounce';
import React from 'react';

export interface UseWindowSizeProps {
  delay?: number;
}

const useWindowSize = ({ delay = 250 }: UseWindowSizeProps = {}) => {
  const [windowSize, setWindowSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  React.useLayoutEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    const debouncedHandleResize = debounce(handleResize, delay);

    window.addEventListener('resize', debouncedHandleResize);

    debouncedHandleResize();

    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [delay]);

  return windowSize;
};

export default useWindowSize;
